import { gql } from "@apollo/client";
import { INTERVIEW_QUESTION_FIELDS, INTERVIEW_RESPONSE_ANSWER_FIELDS } from "graphql/fragments";

const GET_INTERVIEWS = gql`
  ${INTERVIEW_QUESTION_FIELDS}
  ${INTERVIEW_RESPONSE_ANSWER_FIELDS}
  query interviews($profileId: ID, $paginationInfo: PaginationInfo, $filters: InterviewFilter) {
    interviews(profileId: $profileId, paginationInfo: $paginationInfo, filters: $filters) {
      totalCount
      currentPage
      perPage
      nodes {
        id
        uuid
        type
        serviceId
        name
        description
        active
        timeLimit
        videoUrl
        thumbnailUrl
        questions {
          ...InterviewQuestionFields
        }
        responsesCount
        questionsCount
        published
        publishedAt
        archivedAt
        categories {
          id
          name
          uuid
        }
        interviewResponse {
          id
          uuid
          slug
          type
          serviceId
          status
          notes
          answered
          completed
          publicUrl
          privateUrl
          thumbnailUrl
          answers {
            ...InterviewResponseAnswerFields
          }
          answersCount
          startedAt
          completedAt
          approvedAt
          profileId
          interviewId
        }
      }
    }
  }
`;

const GET_INTERVIEW = gql`
  ${INTERVIEW_QUESTION_FIELDS}
  query interview($uuid: ID!) {
    interview(uuid: $uuid) {
      id
      uuid
      type
      serviceId
      name
      description
      active
      timeLimit
      videoUrl
      thumbnailUrl
      questions {
        ...InterviewQuestionFields
      }
      responsesCount
      questionsCount
      publishedAt
      archivedAt
      introVideoUrl
    }
  }
`;

const GET_INTERVIEW_CATEGORIES = gql`
  query interviewCategories($filters: TagFilter) {
    interviewCategories(filters: $filters) {
      nodes {
        name
        id
        uuid
      }
    }
  }
`;

export { GET_INTERVIEWS, GET_INTERVIEW, GET_INTERVIEW_CATEGORIES };
